import * as React from "react";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useLocation, Link } from "react-router-dom";
import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { api } from "../../../../api/api";
export default function BankInfoDialog() {
  // const token = localStorage.getItem('token')
  // const url = 'http://skinsymphonybackend.kwintechnologykw21.com:5000/api/'
  // const api = axios.create({
  //   baseURL: url,
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //     'Content-Type': 'application/json'
  //   }
  // })

  const [treatList, setTreatList] = useState([]);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [bodyParts, setBodyParts] = useState("");
  const [description, setDescription] = useState("");
  const [upCode, setUpCode] = useState("");
  const [upName, setUpName] = useState("");
  const [upBody, setUpBody] = useState("");
  const [upDesc, setUpDesc] = useState("");
  const [bpList, setBpList] = useState([]);
  const [showOnWallet, setShowOnWallet] = useState(false);

  const TreateId = useLocation().pathname.split("/")[2];

  const TreatmentUpdate = () => {
    const data = {
      id: TreateId,
      name: upName,
      code: upCode,
      bodyParts: upBody,
      description: upDesc,
      showOnWallet
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api.put("treatment-list", data, config).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Created Income Data!",
        icon: "success",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });
      // window.location.reload()

      // setMedicineLists([...medicineLists, response.data.list[0]])
      // setMedicineLists(
      //   medicineLists.map(category => {
      //     if (category._id === response.data.list[0]._id) {
      //       return response.data.list[0]
      //     } else {
      //       return category
      //     }
      //   })
      // )

      console.log(response.data.list);
    });
  };

  useEffect(() => {
    const getTreat = async () => {
      try {
        const res = await api.get(
          //"http://backendcherryk.kwintechnologykw11.com:4000/api/procedure-items/" +
          "treatment-list/" + TreateId
        );

        console.log(res.data.data);
        setUpName(res.data.data.name);
        setUpCode(res.data.data.code);
        setUpBody(res.data.data.bodyParts?._id);
        setUpDesc(res.data.data.description);
        setShowOnWallet(res.data.data?.showOnWallet === true);
      } catch (err) {}
    };
    const fetchBodyParts = async () => {
      try {
        const response = await api.get("ho/body-parts");
        setBpList(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchBodyParts();

    getTreat();
  }, []);

  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/treatC">Back</Link>
                </li>
                <li className="breadcrumb-item active">Treatment Update</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Main content --> */}

      <section className="content">
        <div className="container-fluid">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="name">Code</label>
              <input
                type="text"
                className="form-control border border-info"
                name="code"
                defaultValue={upCode}
                onChange={(e) => setUpCode(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                className="form-control border border-info"
                name="name"
                defaultValue={upName}
                onChange={(e) => setUpName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="name">Choose Body Parts</label>
              <select
                name="currency"
                id=""
                className="form-control mt-1"
                value={upBody}
                onChange={(e) => setUpBody(e.target.value)}
              >
                {bpList.map((option, index) => (
                  <option value={option._id} key={index}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="name">Description</label>
              <textarea
                className="form-control"
                id="description"
                defaultValue={upDesc}
                onChange={(e) => setUpDesc(e.target.value)}
              ></textarea>
            </div>
            <div className="form-group">
              <label htmlFor="show-on-wallet">Show On Wallet</label>
              <input
                type="checkbox"
                id="show-on-wallet"
                checked={showOnWallet}
                onChange={(e) => setShowOnWallet(e.target.checked)}
              />
            </div>
          </div>
          <div className="modal-footer">
            <Button className="btn btn-secondary" data-dismiss="modal">
              Close
            </Button>
            <button onClick={TreatmentUpdate} className="btn btn-primary">
              Save
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
// phyo
//maymyat
